/**
 * logTube
 *
 *  ...Console.log tunneling
 *
 */
'use strict';

import Utils from '../HlsUtils';
import Event from '../HlsEvents';
import EventEmitter from 'eventemitter2';


/**
* @access internal
*/
class LogTube {

	constructor( config = {}, di = {}) {
		this._emitter = di.eventEmitter || new EventEmitter();
		this._event = Event.LOGTUBE_LOG;
		Utils.applyConfig(this, config);
	}


	dispose() {
		this._emitter = null;
	}


	get debug() {
		return this._debug;
	}


	set debug(value) {
		this._debug = !!value;
	}

	get event() {
		return this._event;
	}


	set event(value) {
		this._event = value;
	}


	log(message) {
		if (this._debug) {
			if (this._emitter.trigger !== undefined) {
				this._emitter.trigger( this._event, { message });
			}
			else {
				this._emitter.emit( this._event, { message });
			}

		}
	}

}
export default LogTube;





// WEBPACK FOOTER //
// ./src/utils/logTube.js